export const NotFoundErrorCode     = "not_found";
export const ForbiddenErrorCode    = "forbidden";
export const UnauthorizedErrorCode = "unauthorized";

export const PhoneMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

export const GermanyUtcOffset = 2;

export const YouTubeEmbeddingWidth = "650px";
export const YouTubeEmbeddingProp  = "56%";
export const YouTubeEmbeddingHeight = `${Math.round(parseInt(YouTubeEmbeddingWidth) * parseInt(YouTubeEmbeddingProp) / 100)}px`;

